<template>
    <div>
    <app-toolbarcustom app_title="Booking" app_menu="bot"></app-toolbarcustom>
        <template>
            <v-stepper v-model="steppers" class="mt-15 elevation-0">
              <v-stepper-header>
                <v-stepper-step
                  :complete="steppers > 1"
                  step="1"
                >
                  Form
                </v-stepper-step>
          
                <v-divider></v-divider>
          
                <v-stepper-step
                  :complete="steppers > 2"
                  step="2"
                >
                  Summary
                </v-stepper-step>
                
              </v-stepper-header>
          
              <v-stepper-items>
                <v-stepper-content step="1">
                  <v-card
                    class="mb-12 elevation-0"
                  >
                  <v-form enctype="multipart/form-data" ref="form_medical_data" lazy-validation>
                  <v-row>
                    <v-col cols="12" sm="12" md="12" class="mt-2">
                        <v-dialog
                        ref                 ="dialog_booking_date"
                        v-model             ="modal.booking_date"
                        :return-value.sync  ="form.booking_date"
                        width               ="290px"
                        persistent
                    >
                        <template v-slot:activator="{ on }">
                        <v-text-field
                            :value              ="booking_date_value"
                            label               ="Tanggal"
                            prepend-icon  ="event"
                            background-color    ="date"
                            v-on                ="on"
                            v-mask              ="'####-##-##'"
                            placeholder         ="YYYY-MM-DD"
                            id                  ="find_booking_date"
                            outlined
                        ></v-text-field>
                        </template>
                        <v-date-picker v-model="form.booking_date" :min="$functions.PastDate(7)" scrollable>
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="modal.booking_date = false">Cancel</v-btn>
                        <v-btn
                            text
                            color   ="primary"
                            @click  ="GetData('booking_date',form.booking_date)"
                        >
                            OK
                        </v-btn>
                        </v-date-picker>
                    </v-dialog>
                    </v-col>
                    </v-row> 
                    </v-form>
                  </v-card>
                  <v-btn
                    color="primary"
                    @click="NextStep(1)"
                    block
                    :disabled="form.booking_confirm === 'Loading...'?true:false"
                  >
                    {{ form.booking_confirm }}
                  </v-btn>
          
                </v-stepper-content>
          
                <v-stepper-content step="2">
                <v-subheader>Booking: {{$functions.FormatDateIndoWithDayName(form.booking_date)}}</v-subheader>
                    <v-card
                      class="mx-auto mb-2"
                      max-width="344"
                      v-for="row in posts"
                      :key="row.facilities_id"
                    >
                      <v-img
                        :src="row.facilities_attachmentpath_url"
                        height="200px"
                      ></v-img>
                  
                      <v-card-title>
                        {{ row.facilities_desc }}
                      </v-card-title>
                  
                      <v-card-subtitle>
                        <span v-if="row.facilities_capacity !== '0'">Kapasitas: {{ row.facilities_capacity }} Orang</span>
                      </v-card-subtitle>
                  
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="orange lighten-2"
                          text
                          @click="Book('add',row.facilities_id,row.facilities_desc,'')"
                        >
                          <v-icon>add</v-icon>Booking
                        </v-btn>
                  
                      </v-card-actions>
                  
                      <v-expand-transition>
                        <div>
                          <v-divider></v-divider>
                  
                          <v-card-text v-if="row.facilities_book.length > 0">
                            <v-timeline
                                align-top
                                dense
                            >
                                <v-timeline-item
                                v-for="book in row.facilities_book"
                                :key="book.facilitiesbook_id"
                                small
                                >
                                <v-avatar slot="icon">
                                    <img :src="book.facilitiesbook_cuser_avatar_url">
                                  </v-avatar>
                                    <div class="font-weight-normal mt-n4">
                                    <strong>{{ book.facilitiesbook_cuser }}</strong>
                                    </div>
                                    <div>
                                        {{ book.facilitiesbook_starttime }} s/d {{ book.facilitiesbook_endtime }}
                                    </div>
                                    <div>{{ book.facilitiesbook_subject }} <span class="fourth--text" @click="Book('edit',row.facilities_id,row.facilities_desc,book.facilitiesbook_id)" v-if="book.facilitiesbook_cuser === $functions.UsersID()">&bull; [Ubah]</span></div>
                                </v-timeline-item>
                            </v-timeline>
                          </v-card-text>
                          <v-card-text v-else class="text-center font-weight-black">
                            Belum Ada yang booking
                          </v-card-text>
                        </div>
                      </v-expand-transition>
                    </v-card>
                  <v-btn color="secondary" @click="steppers = 1" block>
                    Sebelumnya
                  </v-btn>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </template>
          <v-dialog v-model="booking.dialog" max-width="490" persistent>
            <v-card>
                <v-card-title class="secondary headline white--text">{{booking.title}}</v-card-title>
                <v-card-text>
                    {{booking.text}}
                    <v-form enctype="multipart/form-data" ref="form_facilitiesbook" lazy-validation>
                    <v-row>
                        <v-col cols="12" sm="12" md="12" class="mt-4">
                            <v-dialog
                                ref                 ="dialog_facilitiesbook_date"
                                v-model             ="modal.facilitiesbook_date"
                                :return-value.sync  ="form.facilitiesbook_date"
                                width               ="290px"
                                persistent
                            >
                                <template v-slot:activator="{ on }">
                                <v-text-field
                                    :value              ="facilitiesbook_date_value"
                                    label               ="Tanggal Mulai"
                                    prepend-icon  ="event"
                                    background-color    ="date"
                                    v-on                ="on"
                                    v-mask              ="'####-##-##'"
                                    placeholder         ="YYYY-MM-DD"
                                    id                  ="find_facilitiesbook_date"
                                    outlined
                                ></v-text-field>
                                </template>
                                <v-date-picker v-model="form.facilitiesbook_date" :min="$functions.PastDate(7)" scrollable>
                                <v-spacer></v-spacer>
                                <v-btn text color="primary" @click="modal.facilitiesbook_date = false">Cancel</v-btn>
                                <v-btn
                                    text
                                    color   ="primary"
                                    @click  ="GetData('facilitiesbook_date',form.facilitiesbook_date)"
                                >
                                    OK
                                </v-btn>
                                </v-date-picker>
                            </v-dialog>
                        </v-col>
                        <v-col cols="12" sm="12" md="12" class="mt-n6">
                            <v-dialog
                                ref                 ="dialog_facilitiesbook_untildate"
                                v-model             ="modal.facilitiesbook_untildate"
                                :return-value.sync  ="form.facilitiesbook_untildate"
                                width               ="290px"
                                persistent
                            >
                                <template v-slot:activator="{ on }">
                                <v-text-field
                                    :value              ="facilitiesbook_untildate_value"
                                    label               ="Tanggal Selesai"
                                    prepend-icon  ="event"
                                    background-color    ="date"
                                    v-on                ="on"
                                    v-mask              ="'####-##-##'"
                                    placeholder         ="YYYY-MM-DD"
                                    id                  ="find_facilitiesbook_untildate"
                                    outlined
                                ></v-text-field>
                                </template>
                                <v-date-picker v-model="form.facilitiesbook_untildate" :min="form.facilitiesbook_date" scrollable>
                                <v-spacer></v-spacer>
                                <v-btn text color="primary" @click="modal.facilitiesbook_untildate = false">Cancel</v-btn>
                                <v-btn
                                    text
                                    color   ="primary"
                                    @click  ="GetData('facilitiesbook_untildate',form.facilitiesbook_untildate)"
                                >
                                    OK
                                </v-btn>
                                </v-date-picker>
                            </v-dialog>
                        </v-col>
                            <v-col cols="6" sm="6" md="6" class="mt-n6">
                            <v-dialog
                                ref="dialog_facilitiesbook_starttime"
                                v-model="modal.facilitiesbook_starttime"
                                :return-value.sync="form.facilitiesbook_starttime"
                                persistent
                                width="290px"
                            >
                                <template v-slot:activator="{ on }">
                                <v-text-field
                                    v-model="form.facilitiesbook_starttime"
                                    :rules="form.facilitiesbook_starttime_rules"
                                    label="IN *"
                                    prepend-icon="access_time"
                                    background-color="time"
                                    readonly
                                    v-on="on"
                                    required 
                                    outlined
                                ></v-text-field>
                                </template>
                                <v-time-picker
                                v-if="modal.facilitiesbook_starttime"
                                v-model="form.facilitiesbook_starttime"
                                format="24hr"
                                >
                                <v-spacer></v-spacer>
                                <v-btn text color="primary" @click="modal.facilitiesbook_starttime = false">Cancel</v-btn>
                                <v-btn text color="primary" @click="$refs.dialog_facilitiesbook_starttime.save(form.facilitiesbook_starttime)">OK</v-btn>
                                </v-time-picker>
                            </v-dialog>
                        </v-col>
                        <v-col cols="6" sm="6" md="6" class="mt-n6">
                            <v-dialog
                                ref="dialog_facilitiesbook_endtime"
                                v-model="modal.facilitiesbook_endtime"
                                :return-value.sync="form.facilitiesbook_endtime"
                                persistent
                                width="290px"
                            >
                                <template v-slot:activator="{ on }">
                                <v-text-field
                                    v-model="form.facilitiesbook_endtime"
                                    :rules="form.facilitiesbook_endtime_rules"
                                    label="OUT *"
                                    prepend-icon="access_time"
                                    background-color="time"
                                    readonly
                                    v-on="on"
                                    required 
                                    outlined
                                ></v-text-field>
                                </template>
                                <v-time-picker
                                v-if="modal.facilitiesbook_endtime"
                                v-model="form.facilitiesbook_endtime"
                                format="24hr"
                                >
                                <v-spacer></v-spacer>
                                <v-btn text color="primary" @click="modal.facilitiesbook_endtime = false">Cancel</v-btn>
                                <v-btn text color="primary" @click="$refs.dialog_facilitiesbook_endtime.save(form.facilitiesbook_endtime)">OK</v-btn>
                                </v-time-picker>
                            </v-dialog>
                            </v-col>
                            <v-col cols="12" sm="12" md="12" class="mt-n6">
                                <v-text-field 
                                    v-model="form.facilitiesbook_subject"
                                    :rules="form.facilitiesbook_subject_rules"
                                    prepend-icon="notes"
                                    placeholder="Judul"
                                    label="Judul *"
                                    required
                                    solo-inverted
                                    outlined
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="12" md="12" class="mt-n6">
                                <v-text-field 
                                    v-model="form.facilitiesbook_attendance"
                                    :rules="form.facilitiesbook_attendance_rules"
                                    prepend-icon="group"
                                    placeholder="Invitation"
                                    label="Invitation *"
                                    required
                                    solo-inverted
                                    outlined
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="fourth" outlined @click="Cancel(form.facilitiesbook_id)" v-if="form.facilitiesbook_id">{{booking.cancel}}</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="secondary" outlined @click.stop="booking.dialog = false">{{booking.close}}</v-btn>
                    <v-btn id="dialog_booking_true" color="primary" outlined :disabled = "booking.ok !== 'OK' ? true:false" @click="Confirm('process')">{{booking.ok}}</v-btn>
                </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="confirm.dialog" max-width="490" persistent>
            <v-card>
                <v-card-title class="secondary headline white--text">{{confirm.title}}</v-card-title>
                <v-card-text>
                    {{confirm.text}}
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="secondary" outlined @click.stop="confirm.dialog = false">{{confirm.close}}</v-btn>
                    <v-btn id="dialog_confirm_true" color="primary" outlined :disabled = "confirm.ok !== 'OK' ? true:false" @click="Loading">{{confirm.ok}}</v-btn>
                </v-card-actions>
            </v-card>
          </v-dialog>
          <app-snackbar 
            :dialog="snackbar.dialog"
            :color="snackbar.color"
            :text="snackbar.text"
            :timeout="snackbar.timeout"
            @close="snackbar.dialog = false"
          ></app-snackbar>
    </div>
</template>
<script>
    export default {
        data: () => ({
            steppers: 1,
            url_type: 'add',
            current_date: '',
            posts: [],
            form: {
                facilitiesbook_id: '',
                facilitiesbook_facilitiesid: '',
                facilitiesbook_subject: '',
                facilitiesbook_subject_rules: [v => !!v || 'Mohon isi Judul'],
                facilitiesbook_date: new Date().toISOString().substr(0, 10),
                facilitiesbook_starttime: '09:00',
                facilitiesbook_starttime_rules: [v => !!v || 'Mohon isi Jam Mulai'],
                facilitiesbook_endtime: '09:00',
                facilitiesbook_endtime_rules: [v => !!v || 'Mohon isi Jam Selesai'],
                facilitiesbook_attendance: '',
                facilitiesbook_fullday: 'N',
                facilitiesbook_actived: 'Y',
                facilitiesbook_untildate: new Date().toISOString().substr(0, 10),
                booking_confirm: 'Cek Ketersediaan',
                booking_date: new Date().toISOString().substr(0, 10)
            },
            modal: {
                booking_date: false,
                facilitiesbook_date: false,
                facilitiesbook_untildate: false,
                facilitiesbook_starttime: false,
                facilitiesbook_endtime: false,
            },
            loading: {
                page: false
            },
            upload: {
                dialog: false,
                title: '',
                text: '',
                ok: 'OK',
                close: 'Tutup',
                upload: 'Upload',
                delete: 'Hapus',
                src: '',
                target: '',
            },
            booking: {
                dialog: false,
                title: '',
                text: '',
                ok: 'OK',
                close: 'Tutup',
                cancel: 'Batal',
            },
            access: {
                read: 0
            },
            confirm: {
                dialog: false,
                title: '',
                text: '',
                ok: 'OK',
                close: 'Tutup',
            },
            snackbar: {
                dialog: false,
                timeout: 3000,
                text: '',
                color: 'error'
            },
            format_amount: {
                locale: "id-ID",
                prefix: "",
                suffix: "",
                length: 15,
                precision: 2
            },
            // Format Properties
            properties: {
                reverse: true,
                'prepend-icon':'money'
            },
        }),
         // Check If Back Button Press, Modal Close
         beforeRouteLeave (to, from, next) {
            if (this.modal.booking_date) {
                this.modal.booking_date = false
                next(false)
            } else {
                next()
            }
        },
        computed: {
            booking_date_value () {
                return this.form.booking_date ? this.$moment(this.form.booking_date).format('LL') : ''
            },
            facilitiesbook_date_value () {
                return this.form.facilitiesbook_date ? this.$moment(this.form.facilitiesbook_date).format('LL') : ''
            },
            facilitiesbook_untildate_value () {
                return this.form.facilitiesbook_untildate ? this.$moment(this.form.facilitiesbook_untildate).format('LL') : ''
            },
        },
        methods: {
            GoTo (url) {
               this.$router.push(url)
            },
            Book (type,id, desc, detail) {
                this.url_type = 'booking'+type
                this.booking.dialog =  true
                this.booking.title =  desc
                if (type === 'edit') {
                    this.booking.text = 'Ubah Data '+detail
                    this.form.facilitiesbook_facilitiesid = id
                    this.form.facilitiesbook_id = detail
                } else {
                    this.form.facilitiesbook_id = ''
                    this.form.facilitiesbook_facilitiesid = id
                }
            },
            Confirm (flag) {
                if (flag === 'process') {
                    let validation = ''
                    if (this.form.facilitiesbook_date === '') {
                        validation = 'Mohon isi Tanggal Mulai'
                    } else if (this.form.facilitiesbook_untildate === '') {
                        validation = 'Mohon isi Tanggal Selesai'
                    } else if (this.form.facilitiesbook_starttime === '') {
                        validation = 'Mohon isi Jam Mulai'
                    } else if (this.form.facilitiesbook_endtime === '') {
                        validation = 'Mohon isi Jam Selesai'
                    } else if (this.form.facilitiesbook_subject === '') {
                        validation = 'Mohon isi Judul'
                    } else if (this.form.facilitiesbook_attendance === '') {
                        validation = 'Mohon isi Invitation'
                    }
                    if (validation !== '') {
                        this.SnackBar(true, 'error', validation, 0)
                    } else {
                        this.confirm.dialog   = true
                        this.confirm.title    = 'Simpan?'
                        setTimeout(function(){
                        document.getElementById('dialog_confirm_true').focus()
                        }, 500)
                    }
                }
            },
            Cancel (id) {
                if (id === '') {
                    alert('Book ID Not Found')
                } else {
                    this.confirm.dialog   = true
                    this.confirm.title    = 'Batal?'
                    this.url_type         = 'bookingcancel'
                    this.form.facilitiesbook_id = id
                    setTimeout(function(){
                    document.getElementById('dialog_confirm_true').focus()
                    }, 500)
                }
            },
            Loading () {
                this.confirm.ok = 'Loading...'
                this.Write()
            },
            Booking () {
                this.form.booking_confirm = 'Loading...'
                let formdata = {
                  facilities_date: this.form.booking_date,
                  order_by: 'facilities_sortno',
                  order_type: 'ASC'
                }
                let param 	   = this.$functions.ParamPOST(formdata)
                this.$axios.post(this.$functions.UrlPOST('apiListFacilities'),param,{
                    headers: {
                        'Content-Type': 'text/plain; charset=ISO-8859-1'
                    }
                })
                .then(response => {
                    let feedback = response.data
                    if (feedback.length > 0) {
                        if (feedback[0].feedback === 'Y') {
                            this.posts = feedback
                            this.steppers = 2
                        } else {
                            this.SnackBar(true, 'error', feedback[0].feedback, 3000)
                        }
                    } else {
                        this.SnackBar(true, 'error', this.$functions.ErrorCode(), 0)
                    }
                    this.form.booking_confirm = 'Cek Ketersediaan'
                    this.loading.page = false
                })
                .catch(e => {
                    this.SnackBar(true, 'error', e, 3000)
                    this.loading.page = false
                    this.form.booking_confirm = 'Cek Ketersediaan'
                })
            },
            BookingData (id) {
                this.form.booking_confirm = 'Loading...'
                let formdata = {
                  facilitiesbook_id: id
                }
                let param 	   = this.$functions.ParamPOST(formdata)
                this.$axios.post(this.$functions.UrlPOST('apiListFacilitiesBook'),param,{
                    headers: {
                        'Content-Type': 'text/plain; charset=ISO-8859-1'
                    }
                })
                .then(response => {
                    let feedback = response.data
                    if (feedback.length > 0) {
                        if (feedback[0].feedback === 'Y') {
                            this.form.facilitiesbook_id = feedback[0].facilitiesbook_id
                            this.form.facilitiesbook_subject = feedback[0].facilitiesbook_subject
                        } else {
                            this.SnackBar(true, 'error', feedback[0].feedback, 3000)
                        }
                    } else {
                        this.SnackBar(true, 'error', this.$functions.ErrorCode(), 0)
                    }
                    this.form.booking_confirm = 'Cek Ketersediaan'
                    this.loading.page = false
                })
                .catch(e => {
                    this.SnackBar(true, 'error', e, 3000)
                    this.loading.page = false
                    this.form.booking_confirm = 'Cek Ketersediaan'
                })
            },
            Write () {
                let formdata = {
                  url_type: this.url_type,
                  facilitiesbook_id: this.form.facilitiesbook_id,
                  facilitiesbook_facilitiesid: this.form.facilitiesbook_facilitiesid,
                  facilitiesbook_subject: this.form.facilitiesbook_subject,
                  facilitiesbook_date: this.form.facilitiesbook_date,
                  facilitiesbook_starttime: this.form.facilitiesbook_starttime,
                  facilitiesbook_endtime: this.form.facilitiesbook_endtime,
                  facilitiesbook_attendance: this.form.facilitiesbook_attendance,
                  facilitiesbook_untildate: this.form.facilitiesbook_untildate,
                  facilitiesbook_fullday: this.form.facilitiesbook_fullday,
                  facilitiesbook_actived: this.form.facilitiesbook_actived,
                }
                let param 	   = this.$functions.ParamPOST(formdata)
                this.$axios.post(this.$functions.UrlPOST('apiWriteFacilities'),param,{
                    headers: {
                        'Content-Type': 'text/plain; charset=ISO-8859-1'
                    }
                })
                .then(response => {
                    let feedback = response.data
                    if (feedback.length > 0) {
                        if (feedback[0].feedback === 'Y') {
                            this.SnackBar(true, 'success', 'Proses Sukses', 3000)
                            this.Booking()
                        } else {
                            this.SnackBar(true, 'error', feedback[0].feedback, 0)
                        }
                    } else {
                        this.SnackBar(true, 'error', this.$functions.ErrorCode(), 0)
                    }
                    this.booking.dialog 	 = false
                    this.confirm.dialog 	 = false
                    this.confirm.ok 	 	 = 'OK'
                })
                .catch(e => {
                    this.booking.dialog 	 = false
                    this.confirm.dialog 	 = false
                    this.confirm.ok 	 	 = 'OK'
                    this.SnackBar(true, 'error', e, 3000)
                })
            },
            GetData (flag, value) {
                switch (flag) {
                	case 'booking_date':
                		this.$refs.dialog_booking_date.save(value)
                		this.$refs.dialog_facilitiesbook_date.save(value)
                		this.$refs.dialog_facilitiesbook_untildate.save(value)
                        this.form.booking_date = this.$moment(value).format('YYYY-MM-DD')
                        this.form.facilitiesbook_date = this.$moment(value).format('YYYY-MM-DD')
                        this.form.facilitiesbook_untildate = this.$moment(value).format('YYYY-MM-DD')
                    break
                    case 'facilitiesbook_date':
                		this.$refs.dialog_facilitiesbook_date.save(value)
                        this.$refs.dialog_facilitiesbook_untildate.save(value)
                        this.form.facilitiesbook_date = this.$moment(value).format('YYYY-MM-DD')
                        this.form.facilitiesbook_untildate = this.$moment(value).format('YYYY-MM-DD')
                    break
                    case 'facilitiesbook_untildate':
                		this.$refs.dialog_facilitiesbook_untildate.save(value)
                        this.form.facilitiesbook_untildate = this.$moment(value).format('YYYY-MM-DD')
                    break
                }
            },
            NextStep(id) {
                if (id === 1) {
                    let validation = ''
                    if (this.form.booking_date === '') {
                        validation = 'Mohon isi Tanggal'
                    } 
                    if (validation !== '') {
                        this.SnackBar(true, 'error', validation, 0)
                    } else {
                        this.Booking()
                    }
                }
            },
            SnackBar (dialog, color, text, timeout) {
                this.snackbar = {
                    dialog: dialog,
                    color: color,
                    text: text,
                    timeout: timeout
                }
                if (color === 'error') {
                    this.confirm.dialog 	 = false
                    this.confirm.ok 	 	 = 'OK'
                }
            }
        }
    }
</script>